import { query } from '@confluence/query-preloader-tools';

import type { GraphQLContentStatus } from './__types__/ActiveCommentsQuery';
import { CommentType } from './__types__/ActiveCommentsQuery';
import { ActiveCommentsQuery } from './ActiveCommentsQuery.graphql';

export const buildConsistentActiveCommentsQueryPreloadVariables = (contentId: string) => {
	return {
		pageId: contentId,
		contentStatus: ['CURRENT', 'DRAFT'] as GraphQLContentStatus[],
		type: [CommentType.FOOTER],
		first: 1, // Update this with a larger number once we start SSRing footer comments
	};
};

export function preloadFooterComments(contentId: string) {
	if (contentId) {
		return query({
			query: ActiveCommentsQuery,
			variables: buildConsistentActiveCommentsQueryPreloadVariables(contentId),
		});
	} else {
		return Promise.resolve({});
	}
}
